export default "__VITE_ASSET__f8bde6be__"